import { Outlet } from 'react-router-dom';
import Sidebar from '@/pages/admin/dashboard/components/Sidebar';

export default function AdminLayout() {
  return (
    <div className="min-h-screen bg-background-100">
      <div className="flex">
        <Sidebar />
        <main className="flex-1 min-w-0 lg:pl-0">
          <Outlet />
        </main>
      </div>
    </div>
  );
}